/* @flow */
import * as React from 'react';
import { css } from 'linaria';

import Colors from '../../../constants/Colors';
import Carousel, { CarouselItem } from '../../../components/Carousel';
import MediaQueries from '../../../constants/MediaQueries';
import Review from '../../../components/Review';
import Reviews, { getReviewsTagged } from '../../../../data/Reviews';

function HomePageReviews({ theme = 'light' }: { theme?: 'light' | 'dark' }) {
  return (
    <div style={{ textAlign: 'center' }}>
      <Carousel>
        {getReviewsTagged(Reviews, 'home-page-carousel').map((review, i) => {
          return (
            <CarouselItem className={Styles.CarouselItem} key={`review-${i}`}>
              <Review review={review} theme={theme} />
            </CarouselItem>
          );
        })}
      </Carousel>
    </div>
  );
}

const Styles = {
  CarouselItem: css`
    width: 100%;
    ${MediaQueries.Medium} {
      padding: 0 100px;
    }
  `,
  Title: css`
    margin-bottom: 10px;
    display: inline-block;
  `,
  YelpLogo: css`
    margin: 0 4px;
  `,
  YelpText: css`
    margin: 80px 0 32px;
  `,
  YelpName: css`
    color: ${Colors.Black};
  `,
};

export default HomePageReviews;



// WEBPACK FOOTER //
// ./src/ui/pages/HomePage/components/HomePageReviews.js